import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useCategory } from '../../context/CategoryContext';
import { FaSpinner } from 'react-icons/fa';

import energia from '../../img/SOLAR.png';
import software from '../../img/ARQ.png';
import carroussel from "../../img/carrossel.png";
import ELECTRONICOS from "../../img/ELECTRONICOS.png";

import './Carrossel.css';

const Carrossel = () => {
  const { setCategory } = useCategory();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500); // Simula carregamento
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div className="loading-container">
        <FaSpinner className="spinner" size={30} />
      
      </div>
    );
  }

  return (
    <Carousel className="custom-carousel">
      <Carousel.Item>
        <Link to={`/`} className="card-link">
          <img
            className="d-block w-100 custom-carousel-img"
            src={carroussel}
            alt="Primeira imagem"
          />
        </Link>
      </Carousel.Item>

      <Carousel.Item>
        <Link
          to={`/category/software`}
          className="card-link"
          onClick={() => setCategory("Software")}
        >
          <img
            className="d-block w-100 custom-carousel-img"
            src={software}
            alt="Segunda imagem"
          />
        </Link>
      </Carousel.Item>

      <Carousel.Item>
        <Link
          to={`/category/energia`}
          className="card-link"
          onClick={() => setCategory("Energia")}
        >
          <img
            className="d-block w-100 custom-carousel-img"
            src={energia}
            alt="Terceira imagem"
          />
        </Link>
      </Carousel.Item>
      <Carousel.Item>
        <Link
          to={`/category/informatica`}
          className="card-link"
          onClick={() => setCategory("Energia")}
        >
          <img
            className="d-block w-100 custom-carousel-img"
            src={ELECTRONICOS}
            alt="Terceira imagem"
          />
        </Link>
      </Carousel.Item>
    </Carousel>
  );
};

export default Carrossel;
